import { Provider } from '@angular/core';
import { FilterHttpService } from './abstract';
import { FiltersDataHttpServiceImpl } from './filters-data-http.service';

export const FiltersDataHttpProvider: Provider = {
	provide: FilterHttpService,
	useClass: FiltersDataHttpServiceImpl,
};
